export default __webpack_public_path__ + "static/figure-hero-reference-85bf4c9ae5d12b21938ee1b69bb767ff.jpg";